type Props = {
  children: any;
};

export const MainContent = (props: Props): JSX.Element => {
  return <div className="main-content">{props.children}</div>;
};

export const Content = (props: Props): JSX.Element => {
  return <div className="d-flex inner-content">{props.children}</div>;
};

type RightActionsProps = {
  children: any;
  className?: string;
};

export const RightActions = (props: RightActionsProps): JSX.Element => {
  return <div className={`right-actions float-right ${props.className || ''}`}>{props.children}</div>;
};

export const ContentWrapper = (props: Props): JSX.Element => {
  return <div className="content-wrapper">{props.children}</div>;
};